import Intention from "./Intention";
export default Intention;

// Main components
export { default as Message } from './Message';
export { default as MessageItem } from './MessageItem';

// Context and Provider
export {
  MessageProvider,
  useMessageContext,
  useMessageActions as useMessageActionsContext,
  useIntentionLoadingStates,
} from './MessageContext';

// Types
export type {
  IntentionItem,
  MessageProps,
  MessageItemProps,
  ActionButtonConfig,
} from './types';

// Utilities
export {
  sortIntentionsByDate,
  isMessageSharedWithUser,
  getInputRightPadding,
  shouldShowAcceptDeclineActions,
  shouldShowShareDeleteActions,
  shouldShowShareAction,
  getBadgeColorScheme,
  stopPropagation,
} from './utils';

// Constants
export {
  STYLES,
  ACTION_BUTTON_CONFIGS,
  I18N_KEYS,
  DEFAULT_MESSAGES,
  QUERY_KEYS,
} from './constants';

// Hooks (deprecated - use context-based hooks instead)
export { useMessageActions } from './useMessageActions';
